<template>
  <b-modal
    ref="modal"
    :visible="true"
    static
    lazy
    centered
    no-fade
    :title="title"
    hide-footer
    @hide="onHide"
    @hidden="onHidden"
  >
    <form @submit.prevent="submit" novalidate>
      <div class="form-group">
        <label class="small font-weight-bold text-muted" for="csf-title">Наименование <span class="text-danger">*</span></label>
        <input id="csf-title" v-model="form.title" type="text" class="form-control form-control-sm csf__title" :disabled="busy" maxlength="255">
      </div>
      <div class="form-group">
        <label class="small font-weight-bold text-muted" for="csf-price">Стоимость, ₽ <span class="text-danger">*</span></label>
        <input id="csf-price" v-model="form.price" type="number" min="0" step="0.01" class="form-control form-control-sm csf__price" :disabled="busy">
      </div>
      <ul v-if="errors.length" class="alert alert-danger py-2 pl-4 mb-3" role="alert">
        <li v-for="(e, i) in errors" :key="i">{{ e }}</li>
      </ul>
      <div class="d-flex justify-content-between">
        <button type="button" class="btn btn-secondary btn-sm csf__cancel" :disabled="busy" @click="hideModal">Отмена</button>
        <button type="submit" class="btn btn-success btn-sm csf__submit" :disabled="busy">
          <span v-if="busy" class="spinner-border spinner-border-sm mr-1" role="status" aria-hidden="true"></span>Сохранить
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import * as api from '@/components/management/dispatcher/api';
import {
  emptyConsumableForm, consumableFormFromRow, validateConsumableForm, buildConsumablePayload,
} from '@/components/management/dispatcher/catalogPayload';
import { notifySuccess, notifyError } from '@/components/management/dispatcher/notify';
import modalCloseMixin from '@/components/management/dispatcher/map/modalCloseMixin';

export default {
  name: 'ConsumableFormModal',
  mixins: [modalCloseMixin],
  props: {
    row: { type: Object, default: null },
  },
  data() {
    return {
      form: this.row ? consumableFormFromRow(this.row) : emptyConsumableForm(),
      errors: [],
      busy: false,
    };
  },
  computed: {
    title() { return this.row ? 'Изменение расходника' : 'Новый расходник'; },
  },
  methods: {
    async submit() {
      if (this.busy) return;
      this.errors = validateConsumableForm(this.form);
      if (this.errors.length) return;
      this.busy = true;
      try {
        const payload = buildConsumablePayload(this.form, this.row);
        const saved = this.row ? await api.updateConsumable(payload) : await api.createConsumable(payload);
        notifySuccess(this, 'Расходник сохранён');
        this.$emit('saved', saved);
        this.hideModal();
      } catch (e) {
        notifyError(this, e);
      } finally {
        this.busy = false;
      }
    },
  },
};
</script>
